export const AIRSPACE_API_HOST = import.meta.env.VITE_AIRSPACE_API_URL;

export const SUMMARY_PATH = '/api/airspace/restrictions/summary';

// Backend validates radius with .min(100).max(10000). 100m keeps "this point" semantics
// while satisfying the API's minimum. Verified in aai-airspace-service/src/routes/airspace.ts.
export const DEFAULT_RADIUS_M = 100;

export const JSON_HEADERS = { 'Content-Type': 'application/json' };
